export const initialErrors = {
  id: null,
  title: null,
};

export type initialErrorsType = typeof initialErrors;

export const ProductTypeTableHeader = [
  {
    id: 'title',
    numeric: true,
    label: 'Title',
  },
  {
    id: '',
    numeric: false,
    label: '',
  },
];

// TRYON General Index

export const imageSizeOptions = [
  { value: '1024x1024', label: '1024 × 1024' },
  { value: '768x768', label: '768 × 768' },
  { value: '768x512', label: '768 × 512' },
  { value: '512x512', label: '512 × 512' },
];

export const AIMdelOptions = [
  { value: 'Chat GPT', label: 'CHAT GPT' },
  { value: 'DELI', label: 'DELI' },
  { value: 'SONET', label: 'SONET' },
  { value: 'DAVINCI', label: 'DAVINCI' },
];
